import CuentaCard from "./CuentaCard";
export default CuentaCard;